import { toFeatureState } from '@etrigan/feature-toggles-client'
import {
    DataLayerEventName,
    isComponentEnabled,
    NavEventArgs,
    NavItem,
    usePageEvents,
    useToggleState,
    useFeature,
} from '@news-mono/web-common'
import React, { FC } from 'react'
import { TNQuickLinksProps } from './TNQuickLinks'
import {
    StyledLink,
    StyledNav,
    StyledNavItem,
    StyledNavList,
    TNStyledQuickLinks,
} from './TNQuickLinks.styled'
import kebabCase from 'lodash'

export const TNQuickLinksWeb: FC<TNQuickLinksProps> = React.memo(
    ({ links, onEvent, hasBackgroundFill }) => {
        usePageEvents(() => {
            onEvent({
                type: DataLayerEventName.navAvailable,
                originator: 'TNQuickLinks',
                payload: {},
            })
        }, ['page-load-complete'])

        const handleClick = (args: NavEventArgs) => {
            onEvent({
                type: DataLayerEventName.navClicked,
                originator: 'TNQuickLinks',
                payload: {
                    navName: 'TNQuickLinks',
                    navLocation: 'Header',
                    navPos: args.navPos,
                    navText: args.navText,
                    navLink: args.navLink,
                },
            })
        }

        const featureState = useToggleState()
        const federalElectionNavEnabled = useFeature(
            'federal-election-sitewide-navigation',
        )

        return (
            <TNStyledQuickLinks
                hasBackgroundFill={hasBackgroundFill || false}
                isCompact={federalElectionNavEnabled}
            >
                <StyledNav>
                    <StyledNavList>
                        {links
                            .filter((item: NavItem) => {
                                if (
                                    item.name &&
                                    item.name === 'Politics' &&
                                    federalElectionNavEnabled
                                ) {
                                    return false
                                }
                                if (item.feature) {
                                    return isComponentEnabled(
                                        toFeatureState(featureState),
                                        {
                                            feature: item.feature,
                                            invertFeatureToggle:
                                                item.invertFeatureToggle,
                                        },
                                    )
                                }
                                return true
                            })
                            .map((item, index) => (
                                <StyledNavItem
                                    key={item.link}
                                    isCompact={federalElectionNavEnabled}
                                >
                                    <StyledLink
                                        to={item.link}
                                        target={
                                            item.newWindow
                                                ? '_blank'
                                                : undefined
                                        }
                                        rel={
                                            item.newWindow
                                                ? 'noopener'
                                                : undefined
                                        }
                                        onClick={() => {
                                            handleClick({
                                                navPos: index,
                                                navText: item.name,
                                                navLink: item.link,
                                            })
                                        }}
                                        id={`${kebabCase(
                                            item.name,
                                        ).lowerCase()}-quicklink`}
                                    >
                                        {item.name}
                                    </StyledLink>
                                </StyledNavItem>
                            ))}
                    </StyledNavList>
                </StyledNav>
            </TNStyledQuickLinks>
        )
    },
)
TNQuickLinksWeb.displayName = 'TNQuickLinksWeb'
